import React, { useState, useEffect } from 'react';
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import { SidebarNavItem } from '../../../../../sidebars';

interface NavMenuProps {
  item: SidebarNavItem;
}

export const NavMenu = (props: NavMenuProps) => {
  const { item } = props;
  const [isSubNavOpen, setIsSubNavOpen] = useState<boolean>(false);
  const [isSuvNavMatch, setSuvNavMatch] = useState<boolean>(false);
  const location = useLocation();
  useEffect(() => {
    const match: boolean | undefined = item.subNav?.some((subNavItem) => {
      return matchPath(location.pathname, {
        path: subNavItem.path,
        exact: true,
        strict: true,
      })?.isExact;
    });
    if (match) {
      setSuvNavMatch(true);
      setIsSubNavOpen(true);
    }
  }, [item.subNav, location.pathname]);

  const activeStyle = {
    // text-gray-100
    '--tw-text-opacity': '1',
    color: 'rgba(243, 244, 246, var(--tw-text-opacity))',
    // bg-gray-700
    '--tw-bg-opacity': '1',
    backgroundColor: 'rgba(55, 65, 81, var(--tw-bg-opacity))',
    // border-gray-100
    '--tw-border-opacity': '1',
    borderColor: 'rgba(243, 244, 246, var(--tw-border-opacity))',
  };

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (item.subNav) {
      e.preventDefault();
      setIsSubNavOpen(!isSubNavOpen);
    }
  };

  return (
    <>
      <NavLink
        className={`flex justify-between content-center mt-1 p-4 list-none h-15 no-underline border-r-4 ${
          !isSuvNavMatch
            ? 'text-gray-400 border-gray-800'
            : 'bg-gray-700 text-gray-100 border-gray-100'
        } hover:bg-gray-700 hover:text-gray-100 hover:border-gray-100`}
        activeStyle={activeStyle}
        exact
        to={item.path}
        onClick={handleClick}
      >
        <div>
          <span className="ml-4">{item.title}</span>
        </div>
        <div>{item.subNav && (isSubNavOpen ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus}  />)}</div>
      </NavLink>
      {isSubNavOpen &&
        item.subNav?.map((subNavItem) => {
          return (
            <NavLink
              className="flex justify-between content-center text-gray-400 mt-1 p-4 list-none h-15 no-underline border-r-4 border-gray-800 hover:bg-gray-700 hover:text-gray-100 hover:border-gray-100"
              activeStyle={activeStyle}
              exact
              to={subNavItem.path}
              key={subNavItem.id}
            >
              <span className="ml-12">{subNavItem.title}</span>
            </NavLink>
          );
        })}
    </>
  );
};

export default NavMenu;
